/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetClassificationListVariablesDTO = Types.Exact<{
  search?: Types.Maybe<Types.Scalars['String']>;
  paging?: Types.Maybe<Types.PagingDTO>;
}>;


export type GetClassificationListDTO = (
  { __typename?: 'Query' }
  & { classifications: Array<(
    { __typename?: 'Classification' }
    & Pick<Types.ClassificationDTO, 'id' | 'name'>
  )> }
);


export const GetClassificationListDocumentDTO = gql`
    query getClassificationList($search: String, $paging: Paging) {
  classifications(
    filter: {archived: {equals: false}, name: {contains: $search}}
    paging: $paging
    sort: [{field: "name", order: ASC}]
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetClassificationList__
 *
 * To run a query within a React component, call `useGetClassificationList` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationList({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetClassificationList(baseOptions?: Apollo.QueryHookOptions<GetClassificationListDTO, GetClassificationListVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassificationListDTO, GetClassificationListVariablesDTO>(GetClassificationListDocumentDTO, options);
      }
export function useGetClassificationListLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetClassificationListDTO, GetClassificationListVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassificationListDTO, GetClassificationListVariablesDTO>(GetClassificationListDocumentDTO, options);
        }
export type GetClassificationListHookResult = ReturnType<typeof useGetClassificationList>;
export type GetClassificationListLazyQueryDTOHookResult = ReturnType<typeof useGetClassificationListLazyQueryDTO>;
export type GetClassificationListQueryResultDTO = Apollo.QueryResult<GetClassificationListDTO, GetClassificationListVariablesDTO>;